import type { GlossaryTerm } from './glossary';

/**
 * Block 3 glossary terms (S13 · Automation taster: Python-минимум + Playwright + AI).
 * Block 3 — автоматизация — осознанно вне CTFL, поэтому istqb-тег опускаем.
 * Заводятся напрямую в GLOSSARY (см. glossary.ts), питают тултипы и поиск.
 * Источник: sprint-13.ts (форм-пас 25 JUN 2026) · правило подсветки 3-4×.
 */

export const BLOCK_3_TERMS: ReadonlyArray<GlossaryTerm> = [
  {
    "id": "test-automation",
    "termRu": "автоматизация тестирования",
    "termEn": "Test Automation",
    "short": "Проверки выполняет код, а не человек: один раз описываешь сценарий — программа повторяет его сама (ночью, на каждом релизе). Снимает рутину и регресс, не заменяет исследовательское тестирование",
    "introducedIn": "S14"
  },
  {
    "id": "playwright",
    "termRu": "Playwright",
    "termEn": "Playwright",
    "short": "Инструмент Microsoft для управления браузером из кода: открыть страницу, найти элемент, кликнуть, заполнить, проверить. Основной автотул в этом курсе",
    "introducedIn": "S14"
  },
  {
    "id": "locator",
    "termRu": "локатор",
    "termEn": "Locator",
    "short": "Способ указать Playwright нужный элемент на странице. Устойчивый локатор (по роли/тексту) не ломается от правок вёрстки, хрупкий (по месту/CSS-цепочке) — ломается",
    "introducedIn": "S14"
  },
  {
    "id": "get-by-role",
    "termRu": "get_by_role",
    "termEn": "get_by_role",
    "short": "Самый устойчивый локатор Playwright: ищет элемент по роли (button/link/textbox) и видимому имени — так же, как видит страницу пользователь и скринридер",
    "introducedIn": "S14"
  },
  {
    "id": "expect-assertion",
    "termRu": "проверка (expect)",
    "termEn": "expect (assertion)",
    "short": "Утверждение, которое делает тест осмысленным: expect(локатор).to_be_visible() ждёт и проверяет ожидаемое. Не выполнилось — тест краснеет (падает). Без проверки тест ничего не доказывает",
    "introducedIn": "S14"
  },
  {
    "id": "auto-waiting",
    "termRu": "автоожидание (auto-waiting)",
    "termEn": "Auto-waiting",
    "short": "Playwright сам ждёт готовности элемента перед каждым действием и в expect — поэтому ручные паузы почти никогда не нужны",
    "introducedIn": "S14"
  },
  {
    "id": "flaky-test",
    "termRu": "флаки-тест",
    "termEn": "Flaky test",
    "short": "Тест, который то проходит, то падает без изменений кода. Частая причина — действие выполнилось раньше, чем элемент был готов; лечится локатором/ожиданием, а не случайной паузой",
    "introducedIn": "S14"
  },
  {
    "id": "time-sleep-antipattern",
    "termRu": "time.sleep (анти-паттерн)",
    "termEn": "time.sleep (anti-pattern)",
    "short": "Фиксированная пауза в коде. Для ожидания не годится: коротко — тест падает, долго — тормозит, а причину флака не лечит. Вместо неё — auto-waiting и проверки",
    "introducedIn": "S14"
  },
  {
    "id": "traceback",
    "termRu": "трейс (traceback)",
    "termEn": "Traceback",
    "short": "Полный текст ошибки Python при падении. Суть обычно в последней строке (TimeoutError, KeyError, strict mode violation) — её и читают первой, а не пугаются красного",
    "introducedIn": "S14"
  },
  {
    "id": "sdet",
    "termRu": "SDET / Automation QA",
    "termEn": "SDET",
    "short": "Software Development Engineer in Test — инженер, который пишет тестовый код и инфраструктуру автотестов. Отдельная профессия и следующий шаг после этого taster-блока",
    "introducedIn": "S14"
  },
  {
    "id": "pytest",
    "termRu": "pytest",
    "termEn": "pytest",
    "short": "Инструмент запуска тестов на Python: находит функции test_* в файлах test_*.py, прогоняет и показывает отчёт (точка — прошёл, F — упал). Одна команда вместо запуска каждого скрипта отдельно",
    "introducedIn": "S15"
  },
  {
    "id": "pytest-playwright",
    "termRu": "pytest-playwright",
    "termEn": "pytest-playwright",
    "short": "Плагин pytest для Playwright: даёт готовую фикстуру page (браузер открыт до теста, закрыт после) — убирает ручную «рамку» открыть/закрыть браузер из каждого теста",
    "introducedIn": "S15"
  },
  {
    "id": "test-function",
    "termRu": "тест-функция",
    "termEn": "test function",
    "short": "Функция-тест: имя начинается с test_, иначе pytest её не найдёт. Внутри — действия и проверка (assert или expect)",
    "introducedIn": "S15"
  },
  {
    "id": "assert-python",
    "termRu": "assert",
    "termEn": "assert",
    "short": "Встроенная проверка Python: assert выражение — «должно быть истинно». Ложно — тест падает. Осторожно с фейками, которые истинны всегда (assert True, page is not None)",
    "introducedIn": "S15"
  },
  {
    "id": "fixture",
    "termRu": "фикстура",
    "termEn": "fixture",
    "short": "Подготовленное окружение, которое pytest готовит до теста и убирает после; тест просит его по имени в скобках. Пример: page — готовая вкладка браузера",
    "introducedIn": "S15"
  },
  {
    "id": "conftest",
    "termRu": "conftest.py",
    "termEn": "conftest.py",
    "short": "Файл общих фикстур; pytest видит его автоматически, импортировать не надо. Место для заготовок вроде «уже залогиненный пользователь»",
    "introducedIn": "S15"
  },
  {
    "id": "class-oop",
    "termRu": "класс",
    "termEn": "Class",
    "short": "Чертёж объекта: описывает, какие данные и действия у него есть. По одному классу создают сколько угодно объектов. Пример: класс User",
    "introducedIn": "S15"
  },
  {
    "id": "object-oop",
    "termRu": "объект",
    "termEn": "Object",
    "short": "Конкретный экземпляр, созданный по классу: u = User(...). Хранит свои данные и умеет свои действия",
    "introducedIn": "S15"
  },
  {
    "id": "init-method",
    "termRu": "__init__",
    "termEn": "__init__",
    "short": "Метод, который задаёт, что объект получает и сохраняет (в self.) при создании. Для Page Object туда складывают локаторы",
    "introducedIn": "S15"
  },
  {
    "id": "self-ref",
    "termRu": "self",
    "termEn": "self",
    "short": "Ссылка объекта на самого себя внутри методов класса: через self. хранят данные и зовут действия (self.username, self.submit.click())",
    "introducedIn": "S15"
  },
  {
    "id": "method-oop",
    "termRu": "метод",
    "termEn": "Method",
    "short": "Действие объекта — функция внутри класса. В Page Object методы — это действия страницы (login, add_to_cart)",
    "introducedIn": "S15"
  },
  {
    "id": "page-object",
    "termRu": "Page Object",
    "termEn": "Page Object",
    "short": "Паттерн: локаторы и действия одной страницы собраны в одном классе. Тесты зовут методы класса; при редизайне правят одно место, а не каждый тест",
    "introducedIn": "S15"
  },
  {
    "id": "codegen",
    "termRu": "Codegen",
    "termEn": "Codegen",
    "short": "Инструмент Playwright: записывает твои клики и ввод в готовый код. Удобен для черновика и поиска локаторов, но проверки (expect) не добавляет — их пишешь сам",
    "introducedIn": "S15"
  },
  {
    "id": "artifact",
    "termRu": "артефакт",
    "termEn": "Artifact",
    "short": "Файл-результат прогона теста: скриншот, видео или trace. Помогает понять, что произошло, особенно при падении без тебя (ночной набор, CI)",
    "introducedIn": "S15"
  },
  {
    "id": "trace-pw",
    "termRu": "trace (Playwright)",
    "termEn": "Trace",
    "short": "Пошаговая запись теста с состоянием страницы на каждом шаге; открывается в trace viewer (playwright show-trace). Самый мощный артефакт для разбора падения",
    "introducedIn": "S15"
  },
  {
    "id": "failure-artifacts",
    "termRu": "артефакты при падении",
    "termEn": "Artifacts on failure",
    "short": "Скриншот/видео/trace, сохраняемые только при падении (--screenshot=only-on-failure и аналоги) — «глаза», когда тест падает без тебя; успешные прогоны не захламляются",
    "introducedIn": "S15"
  },
  {
    "id": "god-object",
    "termRu": "God-object",
    "termEn": "God-object",
    "short": "Анти-паттерн: всё свалено в один огромный класс (логин, корзина, каталог вместе). Любимый перегиб AI при рефакторинге. Лечится: одна страница = один класс",
    "introducedIn": "S15"
  },
  {
    "id": "over-engineering",
    "termRu": "over-engineering",
    "termEn": "Over-engineering",
    "short": "Усложнение без пользы — лишние абстракции и проверки «на всякий случай». Частый перегиб AI; на taster-уровне проще значит лучше",
    "introducedIn": "S15"
  },
  {
    "id": "refactoring",
    "termRu": "рефакторинг",
    "termEn": "Refactoring",
    "short": "Улучшение структуры кода без изменения поведения: вынести локаторы в класс, убрать копипаст. AI силён в рутине рефакторинга, меру задаёшь ты",
    "introducedIn": "S15"
  },
  {
    "id": "ci-cd",
    "termRu": "CI/CD",
    "termEn": "CI/CD",
    "short": "Continuous Integration / Delivery — код автоматически собирается и тестируется на каждое изменение (CI) и готовится к выкатке (CD). Для QA главное — тесты гоняются сами на каждый коммит",
    "introducedIn": "S17"
  },
  {
    "id": "pipeline-ci",
    "termRu": "pipeline (пайплайн)",
    "termEn": "Pipeline",
    "short": "Последовательность автоматических шагов на сервере при изменении кода: взять код, поставить зависимости, прогнать тесты. Упал шаг — пайплайн красный",
    "introducedIn": "S17"
  },
  {
    "id": "github-actions",
    "termRu": "GitHub Actions",
    "termEn": "GitHub Actions",
    "short": "Встроенный в GitHub сервис CI/CD: шаги описываются в YAML-файле в репозитории, GitHub сам запускает их на своих серверах при заданных событиях",
    "introducedIn": "S17"
  },
  {
    "id": "yaml",
    "termRu": "YAML",
    "termEn": "YAML",
    "short": "Текстовый формат конфигов; структура задаётся отступами (пробелами). Главная ловушка новичка — сбитые отступы: один лишний пробел ломает файл",
    "introducedIn": "S17"
  },
  {
    "id": "workflow",
    "termRu": "workflow",
    "termEn": "Workflow",
    "short": "Файл-описание пайплайна (.github/workflows/*.yml): какие события его запускают (on) и какие шаги (steps) выполнить по порядку",
    "introducedIn": "S17"
  },
  {
    "id": "job-step",
    "termRu": "job / step",
    "termEn": "Job / Step",
    "short": "Job — задача пайплайна (например «прогнать тесты»); step — отдельный её шаг (uses или run). Шаги выполняются строго сверху вниз",
    "introducedIn": "S17"
  },
  {
    "id": "runner",
    "termRu": "runner (runs-on)",
    "termEn": "Runner",
    "short": "Машина, на которой выполняется задача (runs-on: ubuntu-latest). Чистый сервер, создаётся заново на каждый прогон — потому в workflow всегда есть шаги установки",
    "introducedIn": "S17"
  },
  {
    "id": "uses-run",
    "termRu": "uses / run",
    "termEn": "uses / run",
    "short": "Два вида шагов: uses — взять готовый кубик-action (actions/checkout); run — выполнить обычную команду в терминале (pip install, pytest)",
    "introducedIn": "S17"
  },
  {
    "id": "upload-artifact",
    "termRu": "upload-artifact / if: failure()",
    "termEn": "upload-artifact",
    "short": "Шаг-action, который прикладывает файлы (скриншоты) к прогону; с if: failure() — только при красном прогоне, чтобы успешные не захламлять",
    "introducedIn": "S17"
  },
  {
    "id": "exit-code",
    "termRu": "exit code",
    "termEn": "Exit code",
    "short": "Код завершения шага: 0 — успех, ненулевой — провал. Ненулевой exit code делает шаг (и весь пайплайн) красным",
    "introducedIn": "S17"
  },
  {
    "id": "matrix-strategy",
    "termRu": "matrix / strategy",
    "termEn": "Matrix",
    "short": "В GitHub Actions — запуск одной задачи в нескольких вариантах (браузеры, версии) автоматически. Список вариантов → столько же параллельных прогонов",
    "introducedIn": "S17"
  },
  {
    "id": "parallel-xdist",
    "termRu": "parallel (pytest-xdist)",
    "termEn": "Parallel",
    "short": "Параллельный прогон тестов: плагин pytest-xdist и флаг -n auto (использовать все ядра) — на большом наборе экономит минуты",
    "introducedIn": "S17"
  },
  {
    "id": "allure",
    "termRu": "Allure",
    "termEn": "Allure",
    "short": "Инструмент наглядных отчётов о тестах: pytest пишет результаты в allure-results, Allure строит HTML с графиками, шагами и вложениями для команды",
    "introducedIn": "S17"
  },
  {
    "id": "cron-schedule",
    "termRu": "cron / schedule",
    "termEn": "cron",
    "short": "Запуск пайплайна по расписанию (schedule + cron-строка из 5 полей). 0 6 * * * = каждый день в 06:00. Тот самый «ночной регресс»",
    "introducedIn": "S17"
  },
  {
    "id": "branch-protection",
    "termRu": "branch protection",
    "termEn": "Branch protection",
    "short": "Настройка репозитория: запрещает мёрджить, пока обязательные проверки (CI) не станут зелёными. Включается в настройках, не в YAML",
    "introducedIn": "S17"
  },
  {
    "id": "gh-secrets",
    "termRu": "GitHub Secrets",
    "termEn": "GitHub Secrets",
    "short": "Безопасное хранилище паролей и токенов в настройках репозитория; в workflow подставляются скрыто и не светятся в логах. Глубокая настройка — вне курса",
    "introducedIn": "S17"
  },
  {
    "id": "selenium",
    "termRu": "Selenium",
    "termEn": "Selenium",
    "short": "Старейший и самый распространённый инструмент автоматизации браузера, стандарт W3C WebDriver. Работает на многих языках; основа фреймворков, включая Selenide. Своих проверок нет — сравниваешь обычным assert",
    "introducedIn": "S16"
  },
  {
    "id": "webdriver",
    "termRu": "WebDriver",
    "termEn": "WebDriver",
    "short": "Стандарт W3C и «переводчик», через который Selenium управляет реальным браузером. На той же WebDriver-семье построен Appium для мобильных",
    "introducedIn": "S16"
  },
  {
    "id": "selenium-manager",
    "termRu": "Selenium Manager",
    "termEn": "Selenium Manager",
    "short": "Встроенный в Selenium 4 механизм, который сам скачивает нужный драйвер браузера. Поэтому webdriver.Chrome() обычно просто работает, без ручной возни с chromedriver",
    "introducedIn": "S16"
  },
  {
    "id": "sel-driver",
    "termRu": "driver (Selenium)",
    "termEn": "driver",
    "short": "«Пульт от браузера»: через объект driver открываешь страницы, ищешь элементы и закрываешь окно. Почти любая строка Selenium начинается с driver. Аналог page в Playwright",
    "introducedIn": "S16"
  },
  {
    "id": "driver-quit",
    "termRu": "driver.quit() / driver.close()",
    "termEn": "quit / close",
    "short": "quit() завершает сессию и закрывает браузер целиком — привычка ставить в конце; close() закрывает только одно окно. Без quit «забытые» браузеры копятся в памяти",
    "introducedIn": "S16"
  },
  {
    "id": "find-element",
    "termRu": "find_element / find_elements",
    "termEn": "find_element",
    "short": "Найти первый элемент по локатору (find_element) или список всех (find_elements). Не нашёл — сразу бросает NoSuchElementException",
    "introducedIn": "S16"
  },
  {
    "id": "by-locator",
    "termRu": "By (способ локатора)",
    "termEn": "By",
    "short": "Способ поиска в find_element(By.СПОСОБ, \"значение\"): By.ID, By.CSS_SELECTOR, By.XPATH, By.LINK_TEXT и др. Предпочитай устойчивое (id, текст) хрупкому (длинный XPath по позиции)",
    "introducedIn": "S16"
  },
  {
    "id": "send-keys",
    "termRu": "send_keys",
    "termEn": "send_keys",
    "short": "Ввод текста в найденное поле в Selenium (аналог fill в Playwright). Очистить поле перед вводом — clear()",
    "introducedIn": "S16"
  },
  {
    "id": "webdriverwait",
    "termRu": "WebDriverWait (явное ожидание)",
    "termEn": "WebDriverWait",
    "short": "Явное ожидание: WebDriverWait(driver, сек).until(условие) ждёт до готовности элемента или до таймаута. «Ручная версия» auto-waiting Playwright; замена вредного time.sleep",
    "introducedIn": "S16"
  },
  {
    "id": "expected-conditions",
    "termRu": "expected_conditions (EC)",
    "termEn": "expected_conditions",
    "short": "Готовые условия ожидания для WebDriverWait: element_to_be_clickable, visibility_of_element_located и др. Подставляются в .until(...)",
    "introducedIn": "S16"
  },
  {
    "id": "implicit-explicit-wait",
    "termRu": "implicit / explicit wait",
    "termEn": "implicit / explicit wait",
    "short": "Implicit — одна настройка implicitly_wait, заставляет find_element подождать; explicit — WebDriverWait в нужном месте под конкретное условие. Explicit точнее",
    "introducedIn": "S16"
  },
  {
    "id": "no-such-element",
    "termRu": "NoSuchElementException",
    "termEn": "NoSuchElementException",
    "short": "Ошибка Selenium: элемент по локатору не найден прямо сейчас. Частая причина — он ещё не появился; лечится явным ожиданием (WebDriverWait), а не time.sleep",
    "introducedIn": "S16"
  },
  {
    "id": "selenium-ide",
    "termRu": "Selenium IDE",
    "termEn": "Selenium IDE",
    "short": "Браузерное расширение для записи действий кликами (record-and-playback) с экспортом в код. Прямой родственник Playwright Codegen; осмысленные проверки добавляешь сам",
    "introducedIn": "S16"
  },
  {
    "id": "find-element-by-legacy",
    "termRu": "find_element_by_* (устар.)",
    "termEn": "find_element_by_*",
    "short": "Стиль Selenium 3 (find_element_by_id и т.п.), убранный в Selenium 4 в пользу единого find_element(By.СПОСОБ, \"значение\"). На современной версии падает с AttributeError",
    "introducedIn": "S16"
  },
  {
    "id": "legacy-code",
    "termRu": "legacy-код",
    "termEn": "Legacy code",
    "short": "Старый код, написанный давно и/или в устаревшем стиле, который всё ещё работает и используется. Часто его нужно понять и поддержать, а не переписать. AI хорош как построчный объяснятор",
    "introducedIn": "S16"
  },
  {
    "id": "appium",
    "termRu": "Appium",
    "termEn": "Appium",
    "short": "Главный инструмент автоматизации мобильных, из той же WebDriver-семьи, что Selenium. Идея та же: find_element(...).click(), только локаторы мобильные (AppiumBy) и на устройстве/эмуляторе",
    "introducedIn": "S16"
  },
  {
    "id": "headless",
    "termRu": "headless",
    "termEn": "headless",
    "short": "Запуск браузера без видимого окна (на сервере смотреть на него некому). Обычный режим для CI; включается опцией при создании драйвера",
    "introducedIn": "S16"
  }
];

export const BLOCK_3_MOBILE_TERMS: ReadonlyArray<GlossaryTerm> = [
  {
    "id": "mobile-testing",
    "termRu": "мобильное тестирование",
    "termEn": "Mobile Testing",
    "short": "Проверка приложений на мобильных устройствах с учётом их специфики: жестов, прерываний, смены сети, разрешений, фрагментации и ограниченных ресурсов. Отдельная дисциплина, а не «веб на маленьком экране».",
    "introducedIn": "S13"
  },
  {
    "id": "native-app",
    "termRu": "нативное приложение",
    "termEn": "Native App",
    "short": "Приложение, написанное под конкретную платформу (Android или iOS) и установленное из магазина. Имеет прямой доступ к возможностям устройства.",
    "introducedIn": "S13"
  },
  {
    "id": "hybrid-app",
    "termRu": "гибридное приложение",
    "termEn": "Hybrid App",
    "short": "Веб-приложение внутри нативной обёртки. Специфический источник багов — «мост» между веб-частью и возможностями устройства.",
    "introducedIn": "S13"
  },
  {
    "id": "mobile-web",
    "termRu": "мобайл-веб",
    "termEn": "Mobile Web",
    "short": "Сайт, который открывается в браузере телефона и не ставится из магазина. demoblaze в device-mode — пример мобайл-веба.",
    "introducedIn": "S13"
  },
  {
    "id": "android",
    "termRu": "Android",
    "termEn": "Android",
    "short": "Мобильная платформа от Google. Главный источник фрагментации: множество производителей, устройств и версий OS.",
    "introducedIn": "S13"
  },
  {
    "id": "ios",
    "termRu": "iOS",
    "termEn": "iOS",
    "short": "Мобильная платформа Apple для iPhone и iPad. Линейка устройств уже, чем у Android, но версии OS и размеры экранов всё равно учитывают в покрытии.",
    "introducedIn": "S13"
  },
  {
    "id": "device-fragmentation",
    "termRu": "фрагментация",
    "termEn": "Device Fragmentation",
    "short": "Разнообразие устройств, версий OS и размеров экранов. Проверить на всех физически нельзя — поэтому строят матрицу покрытия по данным и риску.",
    "introducedIn": "S13"
  },
  {
    "id": "device-coverage-matrix",
    "termRu": "матрица покрытия устройств",
    "termEn": "Device Coverage Matrix",
    "short": "Осознанный выбор устройств и версий OS для тестирования по аналитике популярности и риску, а не «все подряд». Ответ на фрагментацию.",
    "introducedIn": "S13"
  },
  {
    "id": "mobile-gestures",
    "termRu": "жесты",
    "termEn": "Gestures",
    "short": "Способы ввода на сенсорном экране: тап, свайп, щипок (zoom), долгое нажатие. Их и реакцию на них проверяют отдельно от кликов мышью.",
    "introducedIn": "S13"
  },
  {
    "id": "screen-orientation",
    "termRu": "ориентация",
    "termEn": "Screen Orientation",
    "short": "Положение экрана: портрет или ландшафт. Смена ориентации пересоздаёт экран и часто ломает вёрстку или сбрасывает введённые данные.",
    "introducedIn": "S13"
  },
  {
    "id": "device-mode",
    "termRu": "device-mode",
    "termEn": "Device Mode",
    "short": "Режим эмуляции мобильного устройства в DevTools браузера. Позволяет смотреть на сайт «телефонными глазами» без реального устройства.",
    "introducedIn": "S13"
  },
  {
    "id": "interruption",
    "termRu": "прерывание",
    "termEn": "Interruption",
    "short": "Звонок, уведомление или системное событие, уводящее приложение в фон в неудобный момент. Проверяют сохранение состояния и отсутствие двойных операций после возврата.",
    "introducedIn": "S13"
  },
  {
    "id": "app-lifecycle",
    "termRu": "жизненный цикл приложения",
    "termEn": "App Lifecycle",
    "short": "Состояния приложения: активно, ушло в фон, вернулось, выгружено системой. Переходы между ними — частый источник мобильных багов.",
    "introducedIn": "S13"
  },
  {
    "id": "network-throttling",
    "termRu": "network throttling",
    "termEn": "Network Throttling",
    "short": "Эмуляция плохой или отсутствующей сети (Offline, Slow 3G) в DevTools. Быстрый способ проверить поведение мобайл-веба при слабом соединении.",
    "introducedIn": "S13"
  },
  {
    "id": "mobile-permissions",
    "termRu": "разрешения",
    "termEn": "Permissions",
    "short": "Доступ приложения к камере, геолокации, контактам и т.п. Тестируют все ветки: дал, отклонил, отозвал — баги чаще в негативных сценариях.",
    "introducedIn": "S13"
  },
  {
    "id": "deep-link-push",
    "termRu": "deep link / push",
    "termEn": "Deep Link / Push Notification",
    "short": "Deep link открывает конкретный экран приложения по ссылке; push — системное уведомление. Проверяют переход на нужный экран и поведение при тапе по уведомлению.",
    "introducedIn": "S13"
  },
  {
    "id": "emulator-simulator",
    "termRu": "эмулятор / симулятор",
    "termEn": "Emulator / Simulator",
    "short": "Виртуальное устройство для тестов (Android AVD, Xcode Simulator). Удобен для скорости, но не показывает реальные сенсоры, производительность и сеть.",
    "introducedIn": "S13"
  },
  {
    "id": "device-farm",
    "termRu": "девайс-ферма",
    "termEn": "Device Farm",
    "short": "Облако реальных устройств (BrowserStack, Sauce Labs, Kobiton) для проверки на моделях, которых нет под рукой. Применяют для финальной проверки и покрытия.",
    "introducedIn": "S13"
  },
  {
    "id": "adb-logcat",
    "termRu": "adb logcat",
    "termEn": "adb logcat",
    "short": "Просмотр системных логов Android-устройства через инструмент adb. На уровне awareness: помогает приложить логи к мобильному баг-репорту.",
    "introducedIn": "S13"
  },
  {
    "id": "mobile-bug-report",
    "termRu": "мобильный баг-репорт",
    "termEn": "Mobile Bug Report",
    "short": "Баг-репорт, дополненный мобильными полями: точное устройство, версия OS, состояние сети и видеозапись экрана. Без них баг часто невоспроизводим.",
    "introducedIn": "S13"
  },
  {
    "id": "screen-recording",
    "termRu": "запись экрана",
    "termEn": "Screen Recording",
    "short": "Видео происходящего на экране устройства. Лучшее доказательство для багов про жесты и анимации, которые трудно описать словами.",
    "introducedIn": "S13"
  }
];
